import React from 'react';
import Page from '../components/Page';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Modal,
  Input,
  Form,
} from 'reactstrap';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdFilterList,
  MdDateRange,
} from 'react-icons/md';
import axios from 'axios';
import LocationDetails from '../components/LocationDetails';
import Moment from 'react-moment';

const month = [
  {
    number: '1',
    text: 'Jan',
  },
  {
    number: '2',
    text: 'Feb',
  },
  {
    number: '3',
    text: 'Mar',
  },
  {
    number: '4',
    text: 'Apr',
  },
  {
    number: '5',
    text: 'May',
  },
  {
    number: '6',
    text: 'Jun',
  },
  {
    number: '7',
    text: 'Jul',
  },
  {
    number: '8',
    text: 'Aug',
  },
  {
    number: '9',
    text: 'Sep',
  },
  {
    number: '10',
    text: 'Oct',
  },
  {
    number: '11',
    text: 'Nov',
  },
  {
    number: '12',
    text: 'Dec',
  },
];

class PersonActivityPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      month: '',
      year: '',
      redirect: false,
      activityList: [],
      columnName: [],
      activityId: '',
      siteList: [],
    };
  }

  toggle = id => () => {
    return this.setState({
      modal: !this.state.modal,
      activityId: id,
    });
  };

  changeHandler = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });

    this.getActivityList(name, value);
  };

  getActivityList = (name, value) => {
    const user = StorageService.getSession('user_info');
    let siteKeys = [];

    for (let s of this.state.siteList) {
      siteKeys.push({ sitekey: s.SiteKey });
    }

    const data = {
      session_key: user.session_key,
      PersonID: this.props.match.params.person,
      SiteKey: siteKeys,
    };

    if (name === 'month') {
      data.Month = value;
      data.Year = this.state.year;
    } else {
      data.Month = this.state.month;
      data.Year = value;
    }

    if (data.Month === '' || data.Year === '') {
      return;
    }

    this.getList(data);
  };

  getList = data => {
    const url = process.env.REACT_APP_API_URL;

    axios
      .post(url + ':3000/v1/person/getActivity', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        let count = 0;

        let columns = [];
        if (result.data.length) {
          for (let i of result.data) {
            let total = Object.keys(JSON.parse(i.activity_data)).length;
            if (total > count) {
              count = total;

              for (var prop in JSON.parse(i.activity_data)) {
                let lcprop = prop.toLowerCase();
                if (
                  !columns.includes(lcprop) &&
                  (lcprop === 'mode' ||
                    lcprop === 'name' ||
                    lcprop === 'phone' ||
                    lcprop === 'email' ||
                    lcprop === 'id' ||
                    lcprop === 'temperature')
                ) {
                  columns.push(lcprop);
                }
              }
            }
          }
        }

        this.setState({
          activityList: result.data,
          columnName: columns.sort(),
        });
      })
      .catch(error => {
        //alert(error);
      });
  };

  getCurrentDate(date) {
    let newDate = '';
    if (date === null) {
      newDate = new Date();
    } else {
      newDate = new Date(date);
    }

    let day = newDate.getUTCDate();
    let month = newDate.getUTCMonth() + 1;
    let year = newDate.getUTCFullYear();

    let hour = newDate.getUTCHours();
    let minute = newDate.getUTCMinutes();

    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  getCurrentMonth() {
    let newDate = new Date();
    let month = newDate.getMonth();
    return month;
  }

  getCurrentYear() {
    let newDate = new Date();
    let year = newDate.getFullYear();
    return year;
  }

  getYears = () => {
    const currentYear = new Date().getFullYear();
    let arr = [];

    for (let i = currentYear; i >= 2010; i--) {
      arr.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }

    return arr;
  };

  getSiteList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/site/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          siteList: result.data,
          year: this.getCurrentYear(),
          month: this.getCurrentMonth(),
        });

        let siteKeys = [];

        for (let s of result.data) {
          siteKeys.push({ sitekey: s.SiteKey });
        }

        const data = {
          session_key: user.session_key,
          PersonID: this.props.match.params.person,
          SiteKey: siteKeys,
          Month: this.getCurrentMonth(),
          Year: this.getCurrentYear(),
        };

        this.getList(data);
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getSiteList();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <Page
        className="PersonActivityPage"
        title="Activity"
        breadcrumbs={[
          { name: 'Person', active: false, path: '/person' },
          { name: 'Activity', active: true, path: '' },
        ]}
      >
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Form className="AuthForm mb-4">
                  <Row>
                    <Col md={2}>
                      <div className="d-flex align-items-center">
                        <MdDateRange className="ps-input-icon" />
                        <Input
                          type="select"
                          name="month"
                          value={this.state.month}
                          onChange={this.changeHandler}
                        >
                          <option value="">--Select Month--</option>
                          {month.map((item, index) => {
                            return (
                              <option key={index} value={item.number}>
                                {item.text}
                              </option>
                            );
                          })}
                        </Input>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="d-flex align-items-center">
                        <MdDateRange className="ps-input-icon" />
                        <Input
                          type="select"
                          name="year"
                          value={this.state.year}
                          onChange={this.changeHandler}
                        >
                          <option value="">--Select Year--</option>
                          {this.getYears()}
                        </Input>
                      </div>
                    </Col>
                  </Row>
                </Form>

                <Table responsive className="ps-table ps-tb-horizontal">
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Date/Time</th>
                      {/* {this.state.columnName.length > 0 &&
                        this.state.columnName.map((item, index) => {
                          return (
                            <th key={index}>
                              {item[0].toUpperCase() + item.slice(1)}
                            </th>
                          );
                        })} */}
                      <th>Email</th>
                      <th>ID</th>
                      <th>Mode</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Temperature</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.activityList.length < 1 && (
                      <tr>
                        <td colSpan="9">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.activityList.length > 0 &&
                      this.state.activityList.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{item.name}</td>
                              <td>
                                {/* <Moment format="YYYY-MM-DD HH:mm">
                                  {item.register_dt}
                                </Moment> */}
                                {this.getCurrentDate(item.localdt)}
                              </td>

                              {'email' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['email']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'ID' in JSON.parse(item.activity_data) ? (
                                <td>{JSON.parse(item.activity_data)['ID']}</td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'mode' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['mode']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}
                              {'Name' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['Name']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'phone' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['phone']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'Temperature' in
                              JSON.parse(item.activity_data) ? (
                                <td>
                                  {
                                    JSON.parse(item.activity_data)[
                                      'Temperature'
                                    ]
                                  }
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}
                              <td>
                                <div className="ps-action-button">
                                  <Button
                                    className="theme-button theme-button-primary-light"
                                    onClick={this.toggle(item.activity_data_id)}
                                  >
                                    View
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
          style={{ minWidth: '700px', fontSize: '0.85rem' }}
        >
          <LocationDetails
            history={this.props.history}
            onToggleModal={this.toggle}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default PersonActivityPage;
